import { IconPlayerMarket, IconInventory, IconChassis, IconWeapon, IconMarket, IconForge, IconMods } from '@icons';
import { useAppStore } from '@stores';

export function ArsenalSidebar() {
  const { userData, arsenalTab, setArsenalTab } = useAppStore();

  if (!userData.tutorials.includes('Upgrade')) return null;

  const hasFinishedBlueprints = userData.blueprints
    .some((blueprint) => {
      return blueprint.finishesAt
        && new Date(blueprint.finishesAt!) <= new Date();
    });

  const buttonClass = (tab: string) => {
    let base = `arsenal-${tab} sidebar-button relative`;

    if (tab === arsenalTab) {
      base = `${base} active`;
    } else {
      base = `${base} text-gray-500`;
    }

    if (tab === 'forge' && hasFinishedBlueprints) {
      base = `${base} border-primary border-b-2`;
    }

    return base;
  };

  const tabs = ['weapons', 'chassis', 'mods', 'forge', 'items', 'playerMarket', 'market'];

  return (
    <div className="sidebar">
      <div className="flex-1 flex flex-col overflow-auto">
        {tabs.map((tab) => (
          <button onClick={() => setArsenalTab(tab as any)} className={buttonClass(tab)} key={tab}>
            {tab === 'playerMarket' && <IconPlayerMarket className="p-1.75" />}
            {tab === 'chassis' && <IconChassis className="p-2.5" />}
            {tab === 'market' && <IconMarket className="p-1.75" />}
            {tab === 'items' && <IconInventory className="p-2" />}
            {tab === 'weapons' && <IconWeapon className="p-2" />}
            {tab === 'forge' && <IconForge className="p-2" />}
            {tab === 'mods' && <IconMods className="p-2" />}
          </button>
        ))}
      </div>
    </div>
  );
}